import React from 'react';

const HeroSection = () => {
  return (
    <section className="hero-gradient min-h-screen flex flex-col justify-center items-center text-center px-6 pt-20">
      <div className="max-w-4xl">
        <h1 className="text-6xl md:text-7xl lg:text-8xl font-playfair font-black text-rose mb-6 animate-fade-in-up">
          Wako
        </h1>
        <p className="text-2xl md:text-3xl lg:text-4xl text-charcoal mb-4 font-light animate-fade-in-up animate-delay-1">
          Find Your Own.
        </p>
        <p className="text-base md:text-lg text-charcoal/80 mb-12 max-w-2xl mx-auto leading-relaxed animate-fade-in-up animate-delay-2">
          Zambia's premium matchmaking platform designed for meaningful connections. Quality over quantity, elegance over swiping. Real relationships start here.
        </p>

        <div className="animate-fade-in-up animate-delay-3">
          <a
            href="https://play.google.com/store/apps/details?id=zm.co.wako"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 px-10 py-4 bg-rose text-white font-semibold rounded-full hover:bg-charcoal hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z"/>
            </svg>
            Get it on Google Play
          </a>
          <p className="mt-6 text-sm text-charcoal/60">Trusted across Zambia</p>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;